import EVOLUTIONActions from './EVOLUTIONActions'

export default class NLCActions extends EVOLUTIONActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameCode: `${this.formData.brand !== 'AWC' ? 'S-' : ''}NLC-SLOT-001`,
      platform: 'NLC',
    }

    this.gameName = 'Das xBoot'
  }
}
